<script setup>
import { computed } from 'vue'
import { useVModel } from '@vueuse/core'
import { usePlanningStore } from '@/stores/planning.store'

import { textColor } from '@/lib/utils'

const planningStore = usePlanningStore()

const props = defineProps({
  modelValue: {
    type: [Number, null],
    required: true,
  },
  label: {
    type: String,
    required: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  switchLabelSide: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue'])
const value = useVModel(props, 'modelValue', emit)

const statusLabel = computed(() => planningStore.getConditionLabel(value.value))

const statusColor = computed(() => planningStore.getConditionColor(value.value))

</script>
<template>
  <q-item>
    <q-item-section
      v-if="props.label"
      avatar
    >
      <q-item-label>
        {{ props.label }}
      </q-item-label>
    </q-item-section>
    <q-item-section>
      <q-slider
        id="condition"
        v-model="value"
        class="q-p-sm"
        label-always
        :switch-label-side="props.switchLabelSide"
        :disable="props.disabled"
        :color="statusColor"
        :label-text-color="textColor(statusColor)"
        :min="0"
        :max="4"
        :label-value="statusLabel"
        size="lg"
      />
    </q-item-section>
  </q-item>
</template>
